export enum PerfilFuncionario {
	Comum = 0,
	AdministradorEmpresa = 1,
	AdministradorSistema = 2,
	// Consultoria = 3,
	ConsultorExterno = 4
}

export function getPerfilFuncionarioDescricao(funcao: PerfilFuncionario): string {
	switch (funcao) {
		case PerfilFuncionario.Comum:
			return 'Comum';
		case PerfilFuncionario.AdministradorEmpresa:
			return 'Administrador Empresa';
		case PerfilFuncionario.AdministradorSistema:
			return 'Administrador Sistema';
		case PerfilFuncionario.ConsultorExterno:
			return 'Consultor Externo';
		default:
			return 'Desconhecido';
	}
}
